import { z } from 'zod';
export const relationshipsFinanceCommissionAttributionsCapability = 'relationships.finance-commission-attributions.v1';
export const relationshipsFinanceCommissionAttributionsSlot = 'finance.referral-commission-attributions';
export const relationshipsFinanceCommissionAttributionsProviderId = 'relationships.server.finance-commission-attributions';
const idSchema = z.string().uuid();
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
export const relationshipsFinanceCommissionAttributionsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('finance'),
    requestedCapability: z.literal(relationshipsFinanceCommissionAttributionsCapability),
    resourceType: z.literal('finance.referral-commission-calculation'),
    resourceId: idSchema,
    projectIds: z.array(idSchema).min(1).max(100),
}).superRefine((request, context) => {
    if (new Set(request.projectIds).size !== request.projectIds.length) {
        context.addIssue({ code: 'custom', path: ['projectIds'], message: 'Projects cannot repeat.' });
    }
});
export const relationshipsFinanceCommissionAttributionSchema = z.discriminatedUnion('state', [
    z.strictObject({
        state: z.literal('present'),
        projectId: idSchema,
        attributionId: idSchema,
        referralSourceId: idSchema.nullable(),
        creditedMembershipId: idSchema.nullable(),
        creditSource: z.enum(['lead-assignment', 'uncredited']),
        bookedAt: z.string().datetime({ offset: true }),
        observedAt: z.string().datetime({ offset: true }),
    }),
    z.strictObject({
        state: z.literal('not-attributed'),
        projectId: idSchema,
    }),
    z.strictObject({
        state: z.literal('ambiguous'),
        projectId: idSchema,
        attributionCount: z.number().int().min(2).max(100),
    }),
]);
export const relationshipsFinanceCommissionAttributionsResponseSchema = z.strictObject({
    contractVersion: z.literal(relationshipsFinanceCommissionAttributionsCapability),
    tenantId: idSchema,
    attributions: z.array(relationshipsFinanceCommissionAttributionSchema).min(1).max(100),
    contentHash: sha256Schema,
    observedAt: z.string().datetime({ offset: true }).nullable(),
}).superRefine((response, context) => {
    const projectIds = response.attributions.map(({ projectId }) => projectId);
    if (new Set(projectIds).size !== projectIds.length) {
        context.addIssue({
            code: 'custom', path: ['attributions'], message: 'Attribution facts cannot repeat.',
        });
    }
});
//# sourceMappingURL=relationships-finance-commission-attributions.contract.js.map